module.exports = __webpack_public_path__ + "img/illustration-error.a1bc83c1.svg";